import { render, staticRenderFns } from "./nowGroupRank.vue?vue&type=template&id=04deb6e7&scoped=true"
import script from "./nowGroupRank.vue?vue&type=script&lang=js"
export * from "./nowGroupRank.vue?vue&type=script&lang=js"
import style0 from "./nowGroupRank.vue?vue&type=style&index=0&id=04deb6e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04deb6e7",
  null
  
)

export default component.exports